/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MoneyView } from './MoneyView';
export type ShopInfoView = {
    /**
     * Shop host URL
     */
    host: string;
    /**
     * Shop type
     */
    shopType: ShopInfoView.shopType;
    /**
     * Shop ID
     */
    shopId: string;
    /**
     * Orders count
     */
    ordersCount?: number;
    /**
     * Visitors count
     */
    visitors?: number;
    total?: MoneyView | null;
    /**
     * Is shop enabled
     */
    isEnabled?: boolean;
    /**
     * Is shop online
     */
    isOnline?: boolean;
    /**
     * Is plugin installed
     */
    isPluginInstalled?: boolean;
};
export namespace ShopInfoView {
    /**
     * Shop type
     */
    export enum shopType {
        JTL_SHOP_5 = 'jtl_shop_5',
        JTL_WAWI_1_5 = 'jtl_wawi_1_5',
        JTL_WAWI_1_6 = 'jtl_wawi_1_6',
        EBAY_SHOP = 'ebay_shop',
        AMAZON_SHOP = 'amazon_shop',
        SHOPIFY_SHOP = 'shopify_shop',
    }
}

